// @ts-nocheck
import React from 'react';
import { Mic, MicOff } from 'lucide-react';
import { applyMute } from '@/services/dialer/muteCall';
import { recordingPlaybackUrl, recordingDownloadUrl } from '@/services/dialer/recordingUrl';
import { errorMessage } from '@/services/errorMessage';
import { useState, useEffect, useCallback } from 'react';
// #82/#98 -- autorite unique des libelles de resultat d'appel (voir le module).
import { resolveOutcomeMeta, outcomeLabel, DISPOSITION_VALUES } from '@/services/dialer/callOutcomeLabels';
import { assertCallbackDated } from '@/services/dialer/callbackSchedule';
import { useDialerUI } from '@/contexts/DialerUIContext';
import { LEAD_STATUS_VALUES, leadStatusLabel } from '@/services/dialer/leadStatus';
// #56 -- autorite du snooze (memes durees pour l'UI et pour canCall).
import { isSnoozed, SNOOZE_OPTIONS } from '@/services/dialer/snooze';
import { estPretAAppeler } from '@/services/dialer/readyToCall';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Textarea } from '@/components/ui/textarea';
import { Phone, PhoneOff, RotateCcw, X, Building, MapPin, Users, Briefcase, Calendar, MessageSquare, ClipboardList, PhoneCall, PhoneMissed, Copy, Download, Mail, Linkedin, Globe, Plus, Trash2, Edit3, Check, Star, Send, Loader2, StickyNote, FileText, ThumbsUp, ThumbsDown, Voicemail, ChevronDown, ChevronRight} from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import CallTranscription from './CallTranscription';
import PostCallScore from './PostCallScore';
import CrmSendButton from './CrmSendButton';
import BookedMeetingForm from './BookedMeetingForm';
import BookedOnLinkPanel from './BookedOnLinkPanel';
import { useBookingGesture } from './prospect/useBookingGesture';
import { ActivityTimeline } from './prospect/ActivityTimeline';
import { DISPOSITION_ICONS } from './prospect/dispositionIcons';
import ProspectNotesTab from './prospect/tabs/ProspectNotesTab';
import ProspectCallsTab from './prospect/tabs/ProspectCallsTab';
import ProspectSmsTab from './prospect/tabs/ProspectSmsTab';
import { listCustomers } from '@/api/endpoints/customers';
import { smsSenderOrAuto, smsCapableNumbers, defaultSmsSender } from '@/services/dialer/smsSender';
import { Input } from '@/components/ui/input';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { toast } from 'sonner';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api/api-client';
import { useDialer } from '@/contexts/DialerContext';
import { useIncomingCallSession } from '@/hooks/useIncomingCallSession';
import { useActiveCallActor } from '@/state/useActiveCallActor';
import LiveCallCard from './call-panel/LiveCallCard';
import { useLiveCallState } from './call-panel/useLiveCallState';
import { motion } from 'framer-motion';
import { reportCardTiming } from '@/services/dialer/TwilioCallService';

import { formatDate, formatDateTime } from '@/i18n/locale';
import { formatPhoneNumber } from '@/utils';
import { getEffectiveOutcome, hasMeetingBooked } from '@/utils/callUtils';
import { usePermissions } from '@/hooks/usePermissions';

// #82/#98 -- le dictionnaire local `OUTCOMES` a ete SUPPRIME : il portait
// 8 cles sans `voicemail`, et le badge repliait sur la valeur brute quand
// la cle manquait (d'ou `voicemail`, `ios_filter`, `canceled` affiches tels
// quels). L'autorite est `callOutcomeLabels` + le catalogue `dialer:status.*`.

// 2026-06-03 — Refonte UX Kevin : "Demo reservee" sort de la liste (statut
// particulier, coche independamment) ; les autres passent par un <Select>.
// #82/#98 -- les VALEURS viennent desormais de l'autorite (DISPOSITION_VALUES)
// et les LIBELLES du catalogue i18n. Le second dictionnaire local a disparu :
// on lit et on ecrit avec le meme vocabulaire.
/**
 * #81 -- « LISTS » : la propriete que le client reclame. Le sync HubSpot range
 * desormais la liste d'origine dans `custom_fields.hubspot_list`
 * (HubSpotService.syncContacts) -- avant, elle etait jetee a l'import et la
 * propriete n'avait aucune donnee a afficher. Ici on lui donne son libelle
 * client plutot que la cle technique ; tout autre champ garde son nom.
 */
const LIBELLES_CHAMPS_PERSO: Record<string, string> = {
  hubspot_list: 'LISTS',
};

function libelleChampPerso(cle: string): string {
  return LIBELLES_CHAMPS_PERSO[cle] ?? cle;
}



/** Statuts qu'on peut forcer à la main sur un contact (hors rappel, RUI-05). */
export const STATUS_OVERRIDE_VALUES = ['no_answer', 'contacted', 'meeting_booked', 'not_interested'] as const;

export default function ProspectDetailPanel({ prospect, isOpen, onClose, onCall, onDoNotCall, onRequeue, onEnableCalls, onSnooze, onEndSnooze, inline = false }) {
    const { t } = useTranslation(['dialer', 'common', 'admin']);

    // #55 -- meme lecture que canCall() : les DEUX champs comptent. Le drapeau
    // booleen est conserve pour retrocompat (ADR-032) et le status est canonique.
    const appelsDesactives = prospect?.status === 'do_not_call' || prospect?.do_not_call === true;

    // #56 -- meme lecture que canCall() : on interroge l'autorite, on ne
    // recalcule pas la regle ici.
    const enPause = isSnoozed(prospect);

    // #67 -- Expand / Collapse de l'historique d'appels.
    // Par defaut la vue est REDUITE (badge + date + duree). Le detail (resume IA,
    // actions, enregistrement, notes) ne s'affiche que si l'entree est depliee,
    // soit individuellement, soit par le toggle global "Tout deplier".
    const [allCallsExpanded, setAllCallsExpanded] = useState(false);
    const [expandedCalls, setExpandedCalls] = useState(() => new Set());
    const toggleCallExpanded = (id) => {
        setExpandedCalls((prev) => {
            const next = new Set(prev);
            if (next.has(id)) next.delete(id); else next.add(id);
            return next;
        });
    };
    const {
        selectedCallerId,
        activeCallerNumbers,
        connectedContact,
        activeCalls,
        isOnHold,
        isMuted,
        setIsMuted,
        handleQualifyCall,
        handleStopAll,
        handleHangupAndNext,
        handleHangupAndContinue,
        powerMode,
        selectedCustomerId,
        callerData,
    } = useDialer();
    // RUI-P2 : useDialer() n'expose pas reopenLastProspect ; lu ici il valait
    // undefined, et Raccrocher retombait sur onClose (fiche fermee).
    const { reopenLastProspect, lastProspectContacted } = useDialerUI();
    // "Renseigner un RDV pris" from the card the caller is already on
    // (Kevin, 2026-09-23). The prospect is the one on screen, so there is no
    // selector here; everything after it is BookedMeetingForm, the same
    // component the left-nav dialog uses.
    const [showBookedMeeting, setShowBookedMeeting] = useState(false);
    // Same query key as the sidebar: served from cache, no extra request.
    const { data: customersForMeeting = [] } = useQuery({
        queryKey: ['customers', 'sidebar', { activeOnly: true }],
        queryFn: ({ signal }) => listCustomers({ activeOnly: true, signal }),
        staleTime: 60_000,
    });
    const meetingCustomer = customersForMeeting.find((c) => c.id === (prospect?.customer_id || selectedCustomerId)) ?? null;
    const { pending: gesteEnAttente, gesture: geste } = useBookingGesture(meetingCustomer, prospect?.prospect_phone ?? '');
    // 2026-06-04 (refactor big-bang) — la session inbound est la source de
    // verite pour les appels entrants. La modale lit son state (isLive /
    // isEnded / prospect) et appelle ses actions (handleHangup).
    const incomingSession = useIncomingCallSession();
    // AUDIT-F23: only a tenant admin deletes a prospect of the shared queue.
    const { isTenantAdmin } = usePermissions();
    const hangupNext = handleHangupAndNext || handleHangupAndContinue;
    // Pour un appel inbound, prefere handleHangup de la session (qui gere
    // le cycle complet : disconnect + hangupAllMine + ParallelCall update).
    // Pour un outbound, garde handleStopAll classique.
    const isInboundActive = incomingSession.isLive || incomingSession.isEnded;
    const effectiveHangup = isInboundActive ? incomingSession.handleHangup : handleStopAll;
    // L'etat "Appel terminé" (boutons disparaissent) :
    // - inbound : session.isEnded
    // - outbound : pillState ∈ {ended, voicemail}
    // L'etat "Appel en cours" (boutons visibles) :
    // - inbound : session.isLive
    // - outbound : showLiveCard && pillState !== ended/voicemail
    // Note : on garde la modale ouverte meme en isEnded, juste sans boutons.
    const machineView = useActiveCallActor();

    // ── Appel en cours pour CE prospet ? (refonte modale unifiée 2026-05-21) ──
    // On considère qu'un appel est "en cours dans cette modale" si le
    // connectedContact du contexte pointe sur le même prospet (match par
    // téléphone, robuste aux variantes camelCase/snake_case du contact).
    const liveContact = connectedContact || null;
    const sameProspect = !!liveContact && !!prospect && (
        (liveContact.prospect_phone || liveContact.prospectPhone || liveContact.phone) === prospect.prospect_phone ||
        liveContact.callId && (activeCalls || []).some(
            (ac) => ac.id === liveContact.callId && ac.prospect_phone === prospect.prospect_phone,
        )
    );
    const liveCallId = sameProspect ? (liveContact.callId || null) : null;
    const liveCallStartedAt = sameProspect ? (liveContact.callStartedAt || null) : null;

    const { isLive, pillState, elapsed } = useLiveCallState({
        activeCalls,
        callId: liveCallId,
        callStartedAt: liveCallStartedAt,
        isOnHold,
        machineView,
    });

    // 2026-06-03 — useCallControls retire (controles d'appel deplaces dans
    // FloatingCallBar, LiveCallCard ne rend plus de boutons).
    const showLiveCard = !!liveCallId;

    // Measurement (2026-10-07): the card of a call that just connected is on
    // screen at the frame after next; call:bridged reached the browser at
    // window.__cardReceivedAt[callId] (TwilioDeviceContext).
    useEffect(() => {
        if (!isOpen || !liveCallId) return;
        const received = (window as any).__cardReceivedAt?.[liveCallId];
        if (!received) return;
        delete (window as any).__cardReceivedAt[liveCallId];
        requestAnimationFrame(() => requestAnimationFrame(() => reportCardTiming(liveCallId, received, Date.now(), 'shown')));
    }, [isOpen, liveCallId]);

    const [activeTab, setActiveTab] = useState('activity');
    // #78 -- retour visuel par activite (et non global : sinon les 34 boxes
    // s'allumeraient ensemble).
    const [idLienCopieFiche, setIdLienCopieFiche] = useState(null);
    const [notes, setNotes] = useState(prospect?.notes || '');
    const [newNote, setNewNote] = useState('');
    const [savingNote, setSavingNote] = useState(false);
    // TICKET 7 fix: Local state for primary phone to update UI immediately on swap
    const [localPrimaryPhone, setLocalPrimaryPhone] = useState(prospect?.prospect_phone || '');

    // Parse structured notes (JSON array) or legacy string
    const parsedNotes = React.useMemo(() => {
        if (!notes) return [];
        try {
            const parsed = JSON.parse(notes);
            if (Array.isArray(parsed)) return parsed;
        } catch {}
        // Legacy: single string note
        if (notes.trim()) return [{ text: notes, timestamp: prospect?.updated_date || new Date().toISOString(), pinned: false }];
        return [];
    }, [notes]);
    const [linkedinUrl, setLinkedinUrl] = useState(prospect?.linkedin_url || '');
    const [website, setWebsite] = useState(prospect?.website || '');
    const [prospectTitle, setProspectTitle] = useState(prospect?.prospect_title || '');
    const [loading, setLoading] = useState(false);
    const queryClient = useQueryClient();

    // TICKET 6: Custom fields state
    const [customFields, setCustomFields] = useState(prospect?.custom_fields || {});
    const [isAddingField, setIsAddingField] = useState(false);
    const [newFieldName, setNewFieldName] = useState('');
    const [newFieldValue, setNewFieldValue] = useState('');
    const [editingField, setEditingField] = useState(null);
    const [editingValue, setEditingValue] = useState('');

    // Disposition re-qualification
    const [savingDisposition, setSavingDisposition] = useState(false);

    // Edit primary phone state
    const [editingPrimaryPhone, setEditingPrimaryPhone] = useState(false);
    const [editPrimaryPhoneValue, setEditPrimaryPhoneValue] = useState('');

    // TICKET 7: Multiple phone numbers state
    const [additionalPhones, setAdditionalPhones] = useState(prospect?.additional_phones || []);
    const [isAddingPhone, setIsAddingPhone] = useState(false);
    const [newPhone, setNewPhone] = useState('');
    const [newPhoneLabel, setNewPhoneLabel] = useState('');
    const [editingPhoneIdx, setEditingPhoneIdx] = useState(null);
    const [editingPhoneValue, setEditingPhoneValue] = useState('');

    // TICKET 10: Copy all key info handler
    const handleCopyAllInfo = () => {
        const lines = [];
        if (prospect?.prospect_name) lines.push(`${t('common:field.name')}: ${prospect.prospect_name}`);
        if (prospect?.prospect_title) lines.push(`${t('common:field.title')}: ${prospect.prospect_title}`);
        if (prospect?.prospect_company) lines.push(`${t('common:field.company')}: ${prospect.prospect_company}`);
        if (prospect?.prospect_phone) lines.push(`${t('common:field.phone')}: ${prospect.prospect_phone}`);
        if (prospect?.prospect_email) lines.push(`${t('common:field.email')}: ${prospect.prospect_email}`);
        if (linkedinUrl) lines.push(`LinkedIn: ${linkedinUrl}`);
        if (website) lines.push(`${t('dialer:prospectPanel.copyInfo.website')}: ${website}`);
        // Include latest AI summary if available
        const latestCallWithSummary = callHistory?.find(c => c.ai_summary);
        if (latestCallWithSummary?.ai_summary) {
            lines.push(`\n${t('dialer:prospectPanel.copyInfo.aiSummary')}: ${latestCallWithSummary.ai_summary}`);
        }
        navigator.clipboard.writeText(lines.join('\n'));
        toast.success(t('dialer:prospectPanel.toasts.allInfoCopied'));
    };

    // TICKET 9: SMS state
    const [smsMessage, setSmsMessage] = useState('');
    const [sendingSms, setSendingSms] = useState(false);
    const [smsHistory, setSmsHistory] = useState([]);
    // Le numero depuis lequel le SMS part. Pierrejean, 2026-09-30 : on appelle
    // un contact tantot d'un numero tantot d'un autre, et repondre depuis un
    // troisieme fait arriver le message d'un inconnu. Choisi a la main, propose
    // par defaut sur celui du dernier appel.
    const [numeroEnvoi, setNumeroEnvoi] = useState('');
    // La conversation avec ce prospet, envoyée et reçue, depuis le serveur.
    // Elle ne vivait que dans la mémoire de ce composant : rien de reçu
    // n'apparaissait, et l'envoyé disparaissait à la fermeture de la fiche.
    const loadSmsHistory = useCallback(async () => {
        if (!prospect?.prospect_phone) { setSmsHistory([]); return; }
        const phone = String(prospect.prospect_phone).replace(/[^\d+]/g, '').replace(/^0/, '+33');
        try {
            const r = await api.functions.invoke('listInboundSms', { phone, limit: 100 });
            const messages = r?.data?.messages || [];
            setSmsHistory(messages.map((m) => ({
                direction: m.direction === 'inbound' ? 'inbound' : 'outbound',
                message: m.body,
                // L'autre bout de la conversation : l'expéditeur en entrant.
                to: m.direction === 'inbound' ? m.from : m.to,
                timestamp: m.received_at,
                status: m.direction === 'inbound' ? 'received' : (m.status || 'sent'),
            })));
        } catch { /* on garde ce qui est affiché */ }
    }, [prospect?.prospect_phone]);
    useEffect(() => { if (isOpen) void loadSmsHistory(); }, [isOpen, loadSmsHistory]);
    const numerosSms = smsCapableNumbers(activeCallerNumbers);
    useEffect(() => {
        if (numeroEnvoi) return;
        setNumeroEnvoi(defaultSmsSender(selectedCallerId, activeCallerNumbers));
    }, [numeroEnvoi, selectedCallerId, activeCallerNumbers]);

    // TICKET 9: SMS templates
    // The copy lives in the catalog; only the first name is injected here.
    const smsFirstName = prospect?.prospect_name?.split(' ')[0] || '';
    // The agent signs with their own first name (the template said "Kevin de SWOFT" for everyone).
    const smsAgentFirstName = String(callerData?.caller_name || '').split(' ')[0] || '';
    const smsTemplates = ['followUp', 'meetingReminder', 'firstContact'].map((key) => ({
        label: t(`dialer:prospectPanel.sms.templates.${key}.label`),
        text: t(`dialer:prospectPanel.sms.templates.${key}.text`, { firstName: smsFirstName, agentFirstName: smsAgentFirstName }),
    }));

    // TICKET 9: Send SMS handler
    const handleSendSms = async () => {
        if (!smsMessage.trim()) {
            toast.error(t('dialer:prospectPanel.toasts.emptyMessage'));
            return;
        }
        if (!prospect?.prospect_phone) {
            toast.error(t('dialer:prospectPanel.toasts.noPhone'));
            return;
        }
        setSendingSms(true);
        try {
            // `from` optionnel : le serveur prend le 1er numero actif du tenant
            // si absent. Les erreurs 412 (aucun numero) / 403 (spoofing) /
            // 400 (capability SMS absente) remontent avec message actionable
            // dans le catch via err.data.error.
            await api.functions.invoke('twilioSendSMS', {
                to: prospect.prospect_phone,
                message: smsMessage.trim(),
                // Le numéro choisi pour APPELER ne peut pas décider du SMS :
                // une ligne vocale ferait échouer chaque envoi. Sans sender
                // imposé, le serveur prend le premier numéro capable de SMS.
                // Le numero visible a l'ecran est celui qui part ; sans choix
                // explicite, le serveur prend le premier capable de SMS.
                from: numeroEnvoi || smsSenderOrAuto(selectedCallerId, activeCallerNumbers),
            });
            setSmsMessage('');
            // Le serveur vient d'archiver le sortant : on relit plutôt que de
            // fabriquer une ligne locale qui divergerait du statut réel.
            await loadSmsHistory();
            toast.success(t('dialer:prospectPanel.toasts.smsSent'));
        } catch (err) {
            console.error('Failed to send SMS:', err);
            // Remonte le vrai message backend (err.data = body JSON, cf api-client.js)
            const detail = errorMessage(err, t, 'dialer:prospectPanel.toasts.unknownError');
            toast.error(t('dialer:prospectPanel.toasts.smsFailed', { detail }));
        } finally {
            setSendingSms(false);
        }
    };

    // Fetch call history for this prospect
    // Polling adaptatif : 3s seulement si un appel est ACTIF (état Twilio
    // transitoire), sinon pas de refetch automatique. Sans ça, toute la
    // modale rerend toutes les 3s y compris quand on consulte juste les
    // données passées — ce qui rendait la modale non-responsive.
    const ACTIVE_CALL_STATES = ['dialing', 'ringing', 'connected_to_agent', 'ai_analyzing', 'human_detected'];
    const { data: callHistory = [] } = useQuery({
        queryKey: ['prospect-calls', prospect?.prospect_phone],
        queryFn: async () => {
            if (!prospect?.prospect_phone) return [];
            const calls = await api.entities.ParallelCall.filter({
                prospect_phone: prospect.prospect_phone
            }, '-created_date');
            return calls;
        },
        enabled: !!prospect && isOpen,
        refetchInterval: (query) => {
            const data = query.state.data;
            const hasActiveCall = Array.isArray(data) && data.some(
                (c) => c?.call_status && ACTIVE_CALL_STATES.includes(c.call_status)
            );
            return hasActiveCall ? 3000 : false;
        },
    });

    // Kevin, 2026-10-01 : ne pas proposer « Marquer comme pret a appeler » a un
    // contact qui l'est deja. `callHistory` est trie par date decroissante, donc
    // son premier element est le dernier appel -- la meme entree que lisent
    // canCall() et dialIntent(). Declare APRES la requete : ce fichier porte
    // @ts-nocheck, une lecture avant declaration n'y leverait qu'a l'execution.
    const dejaPret = estPretAAppeler(prospect, callHistory[0] || null);

    // Auto-sync Twilio recordings if some calls miss recording_url
    React.useEffect(() => {
        try {
            if (!isOpen || !prospect?.prospect_phone) return;
            const missing = (callHistory || []).some(c => !c.recording_url && !!c.external_call_id);
            if (!missing) return;
            api.functions.invoke('syncTwilioRecordings', { prospectPhone: prospect.prospect_phone })
                .then(() => {
                    queryClient.invalidateQueries({ queryKey: ['prospect-calls', prospect.prospect_phone] });
                })
                .catch((err) => console.error('Twilio recordings sync failed:', err.message ?? err));
        } catch (e) { console.error('Recording sync effect error:', e); }
    }, [isOpen, prospect?.prospect_phone, Array.isArray(callHistory) ? callHistory.length : 0]);

    // Fetch HubSpot data
    React.useEffect(() => {
        if (!isOpen || !prospect) return;

        // First, use stored data if available
        if (prospect.linkedin_url) setLinkedinUrl(prospect.linkedin_url);
        if (prospect.website) setWebsite(prospect.website);
        if (prospect.prospect_title) setProspectTitle(prospect.prospect_title);

        // Then try to fetch from HubSpot
        if (!prospect.linkedin_url || !prospect.website || !prospect.prospect_title) {
            setLoading(true);
            api.functions.invoke('fetchHubSpotContact', {
                prospectPhone: prospect.prospect_phone,
                prospectName: prospect.prospect_name,
                prospectCompany: prospect.prospect_company
            })
                .then(async ({ data }) => {
                    if (data.success) {
                        const updates = {};
                        if (data.linkedin_url && !linkedinUrl) {
                            setLinkedinUrl(data.linkedin_url);
                            updates.linkedin_url = data.linkedin_url;
                        }
                        if (data.website && !website) {
                            setWebsite(data.website);
                            updates.website = data.website;
                        }
                        if (data.job_title && !prospectTitle) {
                            setProspectTitle(data.job_title);
                            updates.prospect_title = data.job_title;
                        }
                        if (Object.keys(updates).length > 0) {
                            await api.entities.ProspectQueue.update(prospect.id, updates);
                        }
                    }
                })
                .catch((err) => {
                    console.error('HubSpot contact fetch failed:', err.message ?? err);
                })
                .finally(() => setLoading(false));
        }
    }, [isOpen, prospect?.prospect_phone, prospect?.prospect_title]);

    // TICKET 6: Sync custom fields when prospect changes
    React.useEffect(() => {
        if (prospect?.custom_fields) {
            setCustomFields(prospect.custom_fields);
        }
    }, [prospect?.custom_fields]);

    // TICKET 6: Add new custom field
    const handleAddCustomField = async () => {
        if (!newFieldName.trim()) {
            toast.error(t('dialer:prospectPanel.toasts.fieldNameRequired'));
            return;
        }
        const updatedFields = {
            ...customFields,
            [newFieldName.trim()]: newFieldValue.trim()
        };
        try {
            await api.entities.ProspectQueue.update(prospect.id, {
                custom_fields: updatedFields
            });
            setCustomFields(updatedFields);
            setNewFieldName('');
            setNewFieldValue('');
            setIsAddingField(false);
            queryClient.invalidateQueries({ queryKey: ['prospect-queue'] });
            toast.success(t('dialer:prospectPanel.toasts.fieldAdded'));
        } catch (err) {
            console.error('Failed to add custom field:', err);
            toast.error(t('dialer:prospectPanel.toasts.fieldAddError'));
        }
    };

    // TICKET 6: Update custom field
    const handleUpdateCustomField = async (fieldName) => {
        const updatedFields = {
            ...customFields,
            [fieldName]: editingValue.trim()
        };
        try {
            await api.entities.ProspectQueue.update(prospect.id, {
                custom_fields: updatedFields
            });
            setCustomFields(updatedFields);
            setEditingField(null);
            setEditingValue('');
            queryClient.invalidateQueries({ queryKey: ['prospect-queue'] });
            toast.success(t('dialer:prospectPanel.toasts.fieldUpdated'));
        } catch (err) {
            console.error('Failed to update custom field:', err);
            toast.error(t('dialer:prospectPanel.toasts.updateError'));
        }
    };

    // TICKET 6: Delete custom field
    const handleDeleteCustomField = async (fieldName) => {
        const { [fieldName]: _, ...remainingFields } = customFields;
        try {
            await api.entities.ProspectQueue.update(prospect.id, {
                custom_fields: remainingFields
            });
            setCustomFields(remainingFields);
            queryClient.invalidateQueries({ queryKey: ['prospect-queue'] });
            toast.success(t('dialer:prospectPanel.toasts.fieldDeleted'));
        } catch (err) {
            console.error('Failed to delete custom field:', err);
            toast.error(t('dialer:prospectPanel.toasts.deleteError'));
        }
    };

    // TICKET 7: Sync additional phones when prospect changes
    React.useEffect(() => {
        if (prospect?.additional_phones) {
            setAdditionalPhones(prospect.additional_phones);
        }
    }, [prospect?.additional_phones]);

    // TICKET 7: Sync primary phone when prospect changes
    React.useEffect(() => {
        if (prospect?.prospect_phone) {
            setLocalPrimaryPhone(prospect.prospect_phone);
        }
    }, [prospect?.prospect_phone]);

    // TICKET 27: Sync notes when prospect changes (e.g. after query refetch)
    React.useEffect(() => {
        if (prospect?.notes !== undefined) {
            setNotes(prospect.notes || '');
        }
    }, [prospect?.notes]);

    // Reset transient UI states when prospect changes
    React.useEffect(() => {
        setConfirmDelete(false);
        setEditingPrimaryPhone(false);
    }, [prospect?.id]);

    // TICKET 7: Add additional phone number
    const handleAddPhone = async () => {
        if (!newPhone.trim()) {
            toast.error(t('dialer:prospectPanel.toasts.phoneRequired'));
            return;
        }
        const updated = [...additionalPhones, { number: newPhone.trim(), label: newPhoneLabel.trim() || `Tél. ${additionalPhones.length + 2}` }];
        try {
            await api.entities.ProspectQueue.update(prospect.id, {
                additional_phones: updated
            });
            setAdditionalPhones(updated);
            setNewPhone('');
            setNewPhoneLabel('');
            setIsAddingPhone(false);
            queryClient.invalidateQueries({ queryKey: ['prospect-queue'] });
            toast.success(t('dialer:prospectPanel.toasts.phoneAdded'));
        } catch (err) {
            console.error('Failed to add phone:', err);
            toast.error(t('dialer:prospectPanel.toasts.phoneAddError'));
        }
    };

    // TICKET 7: Update phone number
    const handleUpdatePhone = async (idx) => {
        const updated = [...additionalPhones];
        updated[idx] = { ...updated[idx], number: editingPhoneValue.trim() };
        try {
            await api.entities.ProspectQueue.update(prospect.id, {
                additional_phones: updated
            });
            setAdditionalPhones(updated);
            setEditingPhoneIdx(null);
            setEditingPhoneValue('');
            queryClient.invalidateQueries({ queryKey: ['prospect-queue'] });
            toast.success(t('dialer:prospectPanel.toasts.phoneUpdated'));
        } catch (err) {
            console.error('Failed to update phone:', err);
            toast.error(t('dialer:prospectPanel.toasts.updateError'));
        }
    };

    // TICKET 7: Delete phone number
    const handleDeletePhone = async (idx) => {
        const updated = additionalPhones.filter((_, i) => i !== idx);
        try {
            await api.entities.ProspectQueue.update(prospect.id, {
                additional_phones: updated
            });
            setAdditionalPhones(updated);
            queryClient.invalidateQueries({ queryKey: ['prospect-queue'] });
            toast.success(t('dialer:prospectPanel.toasts.phoneDeleted'));
        } catch (err) {
            console.error('Failed to delete phone:', err);
            toast.error(t('dialer:prospectPanel.toasts.deleteError'));
        }
    };

    // TICKET 7: Set as primary phone (swap with main number)
    const handleSetPrimaryPhone = async (idx) => {
        const selectedPhone = additionalPhones[idx];
        const currentPrimary = localPrimaryPhone;
        const updated = [...additionalPhones];
        updated[idx] = { ...updated[idx], number: currentPrimary };
        try {
            await api.entities.ProspectQueue.update(prospect.id, {
                prospect_phone: selectedPhone.number,
                additional_phones: updated
            });
            setLocalPrimaryPhone(selectedPhone.number);
            setAdditionalPhones(updated);
            queryClient.invalidateQueries({ queryKey: ['prospect-queue'] });
            toast.success(t('dialer:prospectPanel.toasts.primaryPhoneUpdated'));
        } catch (err) {
            console.error('Failed to set primary phone:', err);
            toast.error(t('dialer:prospectPanel.toasts.primaryPhoneError'));
        }
    };

    // Helper to get call status styling — palette unifiée (emerald/violet/amber/rose/slate/sky).
    // #82/#98 -- VISUALS ONLY. The `label` this function used to return was a
    // sixth competing outcome dictionary, and nothing read it: the badge has
    // always come from `resolveOutcomeMeta` + the `dialer:status.*` catalog.
    const getCallStatusStyle = (call) => {
        const outcome = getEffectiveOutcome(call);
        if (outcome === 'meeting_booked' || outcome === 'contacted' || outcome === 'connected') {
            return { border: 'border-l-4 border-l-emerald-500', iconBg: 'bg-emerald-100', iconColor: 'text-emerald-700' };
        }
        if (outcome === 'voicemail' || outcome === 'left_voicemail') {
            return { border: 'border-l-4 border-l-violet-400', iconBg: 'bg-violet-100', iconColor: 'text-violet-700' };
        }
        if (outcome === 'no_answer' || outcome === 'not_reachable' || outcome === 'busy') {
            return { border: 'border-l-4 border-l-slate-300', iconBg: 'bg-slate-100', iconColor: 'text-slate-600' };
        }
        if (outcome === 'callback_scheduled' || outcome === 'callback_requested') {
            return { border: 'border-l-4 border-l-amber-400', iconBg: 'bg-amber-100', iconColor: 'text-amber-700' };
        }
        if (outcome === 'not_interested') {
            return { border: 'border-l-4 border-l-rose-300', iconBg: 'bg-rose-50', iconColor: 'text-rose-600' };
        }
        return { border: 'border-l-4 border-l-border', iconBg: 'bg-sky-100', iconColor: 'text-sky-700' };
    };

    // Handle disposition click on latest call
    // #82 -- l'appel vise est desormais EXPLICITE. Le bloc supprime operait sur
    // callHistory[0] sans jamais le dire : c'etait exactement la critique du
    // client ("rattache a aucun appel precis"). Defaut conserve pour les appelants
    // historiques.
    // `extra` carries the fields an outcome needs, e.g. follow_up_at for a
    // callback (RUI-05).
    const handleDispositionUpdate = async (dispositionValue, callId, extra = {}) => {
        const latestCall = callId
            ? callHistory.find((c) => c.id === callId)
            : callHistory[0];
        if (!latestCall?.id) return;
        setSavingDisposition(true);
        try {
            // 2026-05-21 — passe par handleQualifyCall (contexte) plutôt qu'un
            // update direct : il gère la normalisation RDV (drapeau
            // meeting_booked + outcome 'contacted'), la notif, la sync Swoft/
            // HubSpot et le prefill RDV. On lui transmet l'outcome brut choisi.
            if (handleQualifyCall) {
                await handleQualifyCall(latestCall.id, { call_outcome: dispositionValue, ...extra });
            } else {
                const updates = dispositionValue === 'meeting_booked'
                    ? { meeting_booked: true, call_outcome: 'contacted' }
                    : { call_outcome: dispositionValue, ...extra };
                assertCallbackDated(updates);
                await api.entities.ParallelCall.update(latestCall.id, updates);
            }
            queryClient.invalidateQueries({ queryKey: ['prospect-calls'] });
            queryClient.invalidateQueries({ queryKey: ['all-calls'] });
            // The CRM button reads the outcome: a fresh qualification may unlock it.
            queryClient.invalidateQueries({ queryKey: ['crm-send-status', latestCall.id] });
            toast.success(t(dispositionValue === 'meeting_booked' ? 'dialer:prospectPanel.toasts.meetingSaved' : 'dialer:prospectPanel.toasts.outcomeUpdated'));
            // 2026-06-05 — Demande Kevin : ne JAMAIS fermer la modale
            // automatiquement apres une qualif. L'agent peut vouloir relire
            // ses notes, ajuster, ou simplement garder la modale ouverte.
            // La fermeture reste explicite via le bouton X.
        } catch (_e) {
            toast.error(t('dialer:prospectPanel.toasts.updateError'));
        } finally {
            setSavingDisposition(false);
        }
    };

    // Edit primary phone handler
    const handleSavePrimaryPhone = async () => {
        const trimmed = editPrimaryPhoneValue.trim();
        if (!trimmed) { setEditingPrimaryPhone(false); return; }
        try {
            await api.entities.ProspectQueue.update(prospect.id, { prospect_phone: trimmed });
            setLocalPrimaryPhone(trimmed);
            setEditingPrimaryPhone(false);
            queryClient.invalidateQueries({ queryKey: ['prospect-queue'] });
            queryClient.invalidateQueries({ queryKey: ['prospect-calls'] });
            toast.success(t('dialer:prospectPanel.toasts.phoneUpdated'));
        } catch (_e) {
            toast.error(t('dialer:prospectPanel.toasts.updateError'));
        }
    };

    // Delete prospect handler. On traite 404 comme un succes idempotent :
    // le prospect n'existe plus cote serveur (deja supprime via un autre onglet,
    // ou cache React Query pas a jour). Objectif atteint, on ferme le panel.
    const [confirmDelete, setConfirmDelete] = useState(false);

    // Edit identity (nom complet + linkedin) — mini-modale ouverte par le crayon a cote du nom.
    const [editIdentityOpen, setEditIdentityOpen] = useState(false);
    const [editName, setEditName] = useState(prospect?.prospect_name || '');
    const [editLinkedin, setEditLinkedin] = useState(prospect?.linkedin_url || '');
    const [editCompany, setEditCompany] = useState(prospect?.prospect_company || '');
    // Status set by hand ('' = keep what the calls say). It wins over the last
    // call until the next call (dialRules.effectiveLastCall).
    const [editStatus, setEditStatus] = useState('');
    // Commercial qualification ('' = keep the current value). Distinct from
    // editStatus above: that one is the last CALL's outcome, this one is
    // the lead's qualification (new/contacted/qualified/lost) — see
    // src/services/dialer/leadStatus.ts.
    const [editLeadStatus, setEditLeadStatus] = useState('');
    const [savingIdentity, setSavingIdentity] = useState(false);
    const openEditIdentity = () => {
        setEditName(prospect?.prospect_name || '');
        setEditLinkedin(prospect?.linkedin_url || '');
        setEditCompany(prospect?.prospect_company || '');
        setEditStatus('');
        setEditLeadStatus('');
        setEditIdentityOpen(true);
    };
    const handleSaveIdentity = async () => {
        const trimmedName = editName.trim();
        const trimmedLinkedin = editLinkedin.trim();
        if (!trimmedName) {
            toast.error(t('dialer:prospectPanel.toasts.nameRequired'));
            return;
        }
        setSavingIdentity(true);
        try {
            await api.entities.ProspectQueue.update(prospect.id, {
                prospect_name: trimmedName,
                linkedin_url: trimmedLinkedin,
                prospect_company: editCompany.trim(),
                ...(editStatus
                    ? { status_override: editStatus, status_override_at: new Date().toISOString() }
                    : {}),
                ...(editLeadStatus
                    ? { lead_status: editLeadStatus, lead_status_origin: 'manual' }
                    : {}),
            });
            setLinkedinUrl(trimmedLinkedin);
            queryClient.invalidateQueries({ queryKey: ['prospect-queue'] });
            queryClient.invalidateQueries({ queryKey: ['prospect', prospect.id] });
            toast.success(t('dialer:prospectPanel.toasts.identityUpdated'));
            setEditIdentityOpen(false);
        } catch (e) {
            // The connected CRM owns the qualification once it has set one
            // (ProspectQueue.qualifyLead) — a manual edit is refused rather
            // than silently overwriting it.
            if (e?.code === 'LEAD_STATUS_OWNED_BY_CRM') {
                toast.error(t('dialer:prospectPanel.toasts.leadStatusOwnedByCrm'));
            } else {
                toast.error(t('dialer:prospectPanel.toasts.saveError'));
            }
        } finally {
            setSavingIdentity(false);
        }
    };
    const handleDeleteProspect = async () => {
        try {
            await api.entities.ProspectQueue.delete(prospect.id);
            queryClient.invalidateQueries({ queryKey: ['prospect-queue'] });
            toast.success(t('dialer:prospectPanel.toasts.contactDeleted'));
            onClose();
        } catch (err) {
            const msg = String(err?.message || err);
            if (msg.includes('404')) {
                queryClient.invalidateQueries({ queryKey: ['prospect-queue'] });
                toast.success(t('dialer:prospectPanel.toasts.contactAlreadyDeleted'));
                onClose();
                return;
            }
            toast.error(t('dialer:prospectPanel.toasts.deleteError'));
        }
    };

    if (!prospect) return null;

    const tabs = [
        { id: 'activity', label: t('admin:components.prospectDetail.status'), icon: Calendar },
        { id: 'notes', label: t('admin:components.prospectDetail.tabs.notes'), icon: ClipboardList },
        { id: 'calls', label: t('admin:components.prospectDetail.tabs.history'), icon: PhoneCall },
        { id: 'transcription', label: t('admin:components.prospectDetail.tabs.transcription'), icon: FileText },
        { id: 'sms', label: 'SMS', icon: MessageSquare },
    ];

    const content = (
        <div className={inline ? "relative flex flex-col h-full " : "relative flex h-full min-h-0 "}>
                    {/* Left Sidebar - Prospect Info */}
                    <div className={inline ? "w-full bg-muted/30 border-b border-border p-4" : "w-80 bg-muted/30 border-r border-border p-6 overflow-y-auto vf-scroll-discreet flex-shrink-0"}>
                        <div className="flex items-start justify-between mb-6">
                            <div className="flex-1 group/identity">
                                <div className="flex items-center gap-1.5">
                                    <h2 className="text-xl font-bold text-foreground">{prospect.prospect_name}</h2>
                                    <button
                                        onClick={openEditIdentity}
                                        className="p-1 rounded hover:bg-accent transition-all opacity-0 group-hover/identity:opacity-100"
                                        title={t('dialer:prospectPanel.editIdentity.trigger')}
                                    >
                                        <Edit3 className="w-3.5 h-3.5 text-muted-foreground" />
                                    </button>
                                </div>
                                {prospect.prospect_title && (
                                    <p className="text-sm text-foreground/80 mt-1">{prospect.prospect_title}</p>
                                )}
                                {prospect.prospect_company && (
                                    <div className="flex items-center gap-2 mt-2">
                                        <Building className="w-4 h-4 text-foreground/60" />
                                        <p className="text-sm text-foreground font-medium">{prospect.prospect_company}</p>
                                    </div>
                                )}
                                {/* LinkedIn & Website icons + actions (Copier / Supprimer apparaissent au hover) */}
                                <div className="flex items-center gap-3 mt-3 group/actions">
                                    {linkedinUrl ? (
                                        <a href={linkedinUrl} target="_blank" rel="noopener noreferrer" title={t('admin:components.prospectDetail.viewLinkedin')}>
                                            <Linkedin className="w-5 h-5 text-foreground/70 hover:text-foreground transition-colors" />
                                        </a>
                                    ) : (
                                        <Linkedin className="w-5 h-5 text-muted-foreground/40" title={t('admin:components.prospectDetail.linkedinUnavailable')} />
                                    )}
                                    {website ? (
                                        <a href={website} target="_blank" rel="noopener noreferrer" title={t('admin:components.prospectDetail.viewWebsite')}>
                                            <Globe className="w-5 h-5 text-foreground/70 hover:text-foreground transition-colors" />
                                        </a>
                                    ) : (
                                        <Globe className="w-5 h-5 text-muted-foreground/40" title={t('admin:components.prospectDetail.websiteUnavailable')} />
                                    )}
                                    <div className="w-px h-4 bg-border/40 mx-0.5 opacity-0 group-hover/actions:opacity-100 transition-opacity" />
                                    <button
                                        onClick={handleCopyAllInfo}
                                        className="p-1.5 rounded-lg hover:bg-accent transition-all opacity-0 group-hover/actions:opacity-100"
                                        title={t('admin:components.prospectDetail.copyAllInfo')}
                                    >
                                        <Copy className="w-4 h-4 text-muted-foreground/60 hover:text-foreground/80 transition-colors" />
                                    </button>
                                    {prospect.id && isTenantAdmin && (
                                        <button
                                            onClick={() => setConfirmDelete(true)}
                                            className="p-1.5 rounded-lg hover:bg-red-50 transition-all opacity-0 group-hover/actions:opacity-100"
                                            title={t('admin:components.prospectDetail.deleteContact')}
                                        >
                                            <Trash2 className="w-4 h-4 text-muted-foreground/60 hover:text-red-500 transition-colors" />
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Quick Actions */}
                        {!inline && (
                            <div className="space-y-2 mb-6">
                                {/* #55 -- etat "appels desactives". canCall() bloque deja sur
                                    do_not_call ET sur status === 'do_not_call' : le contact sort
                                    de la file sans qu'on touche au moteur d'appel. */}
                                {appelsDesactives ? (
                                    <>
                                        <div className="w-full rounded-lg border border-rose-200 bg-rose-50 px-3 py-2.5 flex items-center gap-2">
                                            <PhoneOff className="w-4 h-4 text-rose-600 flex-shrink-0" />
                                            <span className="text-sm font-medium text-rose-700">
                                                {t('dialer:callBar.callsDisabled')}
                                            </span>
                                        </div>
                                        {onEnableCalls && (
                                            <Button
                                                variant="outline"
                                                onClick={() => onEnableCalls(prospect)}
                                                className="w-full"
                                            >
                                                <Phone className="w-4 h-4 mr-2" />
                                                {t('dialer:callBar.enableCalls')}
                                            </Button>
                                        )}
                                    </>
                                ) : (
                                    <Button
                                        onClick={() => {
                                            if (onCall) onCall(prospect);
                                        }}
                                        className="w-full"
                                    >
                                        <Phone className="w-4 h-4 mr-2" />
                                        {t('common:actions.call')} {formatPhoneNumber(localPrimaryPhone)}
                                    </Button>
                                )}
                                {/* ADR-032 — bouton "Remettre en file" : visible si le prospect
                                    n'est pas placeholder ou DNC. Le handler onRequeue (DialerLayout)
                                    repasse en 'active' + clear tracker session. Auparavant gated
                                    sur status === 'contacted', plus pertinent depuis la
                                    simplification à 3 valeurs. */}
                                {onRequeue && !dejaPret && prospect.status !== 'placeholder' && prospect.status !== 'do_not_call' && (
                                    <Button
                                        variant="outline"
                                        onClick={() => onRequeue(prospect)}
                                        className="w-full"
                                    >
                                        <RotateCcw className="w-4 h-4 mr-2" />
                                        {t('dialer:callBar.requeue')}
                                    </Button>
                                )}
                                {/* #56 -- SNOOZE. Un contact en pause n'est ni archive ni
                                    DNC : il redevient appelable seul a l'echeance. */}
                                {!appelsDesactives && enPause && (
                                    <>
                                        <div className="w-full rounded-lg border border-amber-200 bg-amber-50 px-3 py-2.5 flex items-center gap-2">
                                            <Calendar className="w-4 h-4 text-amber-600 flex-shrink-0" />
                                            <span className="text-sm font-medium text-amber-700">
                                                {t('dialer:callBar.snoozeUntil')} {formatDate(prospect.snoozed_until)}
                                            </span>
                                        </div>
                                        {onEndSnooze && (
                                            <Button
                                                variant="outline"
                                                onClick={() => onEndSnooze(prospect)}
                                                className="w-full"
                                            >
                                                <RotateCcw className="w-4 h-4 mr-2" />
                                                {t('dialer:callBar.snoozeEnd')}
                                            </Button>
                                        )}
                                    </>
                                )}
                                {!appelsDesactives && !enPause && onSnooze && (
                                    // A button like its neighbours (Call, Disable calls) that
                                    // opens the durations: as a Select it looked like a form
                                    // field and put its icon above the label.
                                    <DropdownMenu>
                                        <DropdownMenuTrigger asChild>
                                            <Button variant="outline" className="w-full">
                                                <Calendar className="w-4 h-4 mr-2" />
                                                {t('dialer:callBar.snooze')}
                                                <ChevronDown className="w-4 h-4 ml-auto opacity-60" />
                                            </Button>
                                        </DropdownMenuTrigger>
                                        <DropdownMenuContent align="start" className="w-[var(--radix-dropdown-menu-trigger-width)]">
                                            {SNOOZE_OPTIONS.map(({ key, calcule }) => (
                                                <DropdownMenuItem
                                                    key={key}
                                                    onSelect={() => onSnooze(prospect, calcule(new Date()).toISOString())}
                                                    className="flex items-center justify-between gap-3"
                                                >
                                                    {t('dialer:callBar.snooze' + key.charAt(0).toUpperCase() + key.slice(1))}
                                                    <span className="text-xs text-muted-foreground">
                                                        {formatDate(calcule(new Date()), { day: '2-digit', month: '2-digit' })}
                                                    </span>
                                                </DropdownMenuItem>
                                            ))}
                                        </DropdownMenuContent>
                                    </DropdownMenu>
                                )}
                                {/* #55 -- "Disable calls". Le handler (DialerLayout) ecrit
                                    status + do_not_call + do_not_call_at, la forme deja
                                    employee par l'action de masse. */}
                                {!appelsDesactives && onDoNotCall && prospect.status !== 'placeholder' && (
                                    <Button
                                        variant="outline"
                                        onClick={() => onDoNotCall(prospect)}
                                        className="w-full text-rose-600 hover:text-rose-700 hover:bg-rose-50"
                                    >
                                        <PhoneOff className="w-4 h-4 mr-2" />
                                        {t('dialer:callBar.disableCalls')}
                                    </Button>
                                )}
                            </div>
                        )}

                        {/* Renseigner un RDV pris — the natural place, right where
                            the caller lands after hanging up. Same recording path
                            and same push to Swoft as the left-nav entry. */}
                        {prospect?.id && (
                            <div className="mb-6">
                                {!showBookedMeeting ? (
                                    <Button
                                        variant="outline"
                                        onClick={() => setShowBookedMeeting(true)}
                                        className="w-full"
                                    >
                                        <Calendar className="w-4 h-4 mr-2" />
                                        {t('dialer:bookedMeeting.recordOnProspect')}
                                    </Button>
                                ) : (
                                    <div className="rounded-xl border border-border p-4 space-y-3">
                                        <div className="flex items-center justify-between">
                                            <p className="text-sm font-semibold text-foreground">{t('dialer:bookedMeeting.title')}</p>
                                            <button
                                                type="button"
                                                onClick={() => setShowBookedMeeting(false)}
                                                aria-label={t('common:actions.cancel')}
                                                className="p-1 rounded-lg hover:bg-accent"
                                            >
                                                <X className="w-4 h-4 text-muted-foreground" />
                                            </button>
                                        </div>
                                        {/* Sans CRM branche : pas de formulaire, on ouvre
                                            le lien de prise de rendez-vous et on marque le
                                            rendez-vous comme obtenu. */}
                                        {gesteEnAttente ? (
                                            <div className="h-20 flex items-center justify-center">
                                                <Loader2 className="w-5 h-5 animate-spin text-muted-foreground" />
                                            </div>
                                        ) : geste === 'link' ? (
                                            <BookedOnLinkPanel
                                                prospectId={prospect.id}
                                                customer={meetingCustomer}
                                                onDone={() => setShowBookedMeeting(false)}
                                            />
                                        ) : (
                                            <BookedMeetingForm
                                                prospectId={prospect.id}
                                                customer={meetingCustomer}
                                                compact
                                                onDone={() => setShowBookedMeeting(false)}
                                            />
                                        )}
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Prospect Details */}
                        <div className="space-y-4">
                            <div>
                                <label className="text-xs font-semibold text-foreground/80 uppercase block mb-1">{t('admin:components.prospectDetail.status')}</label>
                                {/* ADR-031 / ADR-032 — ce panneau affiche encore prospect.status brut.
                                    Le tableau ContactsScreen est passé à dialIntent (Sans réponse · N
                                    avec compteur, RDV pris, Pas intéressé...). À aligner en phase 2 du
                                    refactor (ADR-032 : simplification de prospect.status). */}
                                {(() => {
                                    // Cycle entre les statuts au clic. Liste alignée avec le tableau
                                    // (STATUS_META) pour garantir cohérence visuelle 1:1.
                                    // #82/#98 -- VISUALS only here. The labels come from the
                                    // outcome authority (callOutcomeLabels + `dialer:status.*`),
                                    // except the two states it does not carry, which name their key.
                                    const STATUS_CYCLE = [
                                        { key: 'pending', color: 'bg-sky-50 text-sky-700 ring-1 ring-inset ring-sky-200' },
                                        { key: 'contacted', color: 'bg-sky-50 text-sky-700 ring-1 ring-inset ring-sky-200' },
                                        { key: 'do_not_call', color: 'bg-slate-100 text-slate-600 ring-1 ring-inset ring-slate-200' },
                                    ];
                                    // Aliases (même couleur, label différent)
                                    const ALIASES = {
                                        new: { color: 'bg-sky-50 text-sky-700 ring-1 ring-inset ring-sky-200' },
                                        calling: { labelKey: 'dialer:statusPill.callInProgress', color: 'bg-sky-50 text-sky-700 ring-1 ring-inset ring-sky-200' },
                                        placeholder: { labelKey: 'dialer:prospectPanel.status.placeholder', color: 'bg-slate-100 text-slate-600 ring-1 ring-inset ring-slate-200' },
                                    };
                                    const current = STATUS_CYCLE.find((s) => s.key === prospect.status);
                                    const alias = ALIASES[prospect.status];
                                    const meta = current || alias;
                                    if (!meta) {
                                        return <Badge className="bg-slate-100 text-slate-600 ring-1 ring-inset ring-slate-200 border-0">—</Badge>;
                                    }
                                    const metaLabel = meta.labelKey ? t(meta.labelKey) : outcomeLabel(prospect.status, t);
                                    const handleCycle = async () => {
                                        const idx = STATUS_CYCLE.findIndex((s) => s.key === prospect.status);
                                        const next = STATUS_CYCLE[(idx === -1 ? 0 : idx + 1) % STATUS_CYCLE.length];
                                        try {
                                            await api.entities.ProspectQueue.update(prospect.id, { status: next.key });
                                            queryClient.invalidateQueries({ queryKey: ['prospect-queue'] });
                                            toast.success(t('dialer:prospectPanel.toasts.statusChanged', { status: outcomeLabel(next.key, t) }));
                                        } catch (err) {
                                            toast.error(t('dialer:prospectPanel.toasts.statusError'));
                                        }
                                    };
                                    return (
                                        <button
                                            type="button"
                                            onClick={handleCycle}
                                            className="inline-flex"
                                            title={t('dialer:prospectPanel.status.cycleHint')}
                                        >
                                            <Badge className={`${meta.color} border-0 cursor-pointer hover:opacity-80 transition-opacity`}>
                                                {metaLabel}
                                            </Badge>
                                        </button>
                                    );
                                })()}
                            </div>

                            {/* TICKET 7: Multiple phone numbers */}
                            <div>
                                <div className="flex items-center justify-between">
                                    <label className="text-xs font-semibold text-foreground/80 uppercase">{t('admin:components.prospectDetail.phones')}</label>
                                    <button
                                        onClick={() => setIsAddingPhone(true)}
                                        className="p-1 hover:bg-accent rounded-full transition-colors"
                                        title={t('admin:components.prospectDetail.addPhone')}
                                    >
                                        <Plus className="w-3.5 h-3.5 text-foreground/70" />
                                    </button>
                                </div>

                                {/* Primary phone */}
                                <div className="flex items-center gap-2 mt-1 group">
                                    <Star className="w-3.5 h-3.5 text-yellow-500 fill-yellow-500 flex-shrink-0" />
                                    {editingPrimaryPhone ? (
                                        <div className="flex items-center gap-1 flex-1">
                                            <Input
                                                value={editPrimaryPhoneValue}
                                                onChange={(e) => setEditPrimaryPhoneValue(e.target.value)}
                                                className="h-7 text-sm flex-1"
                                                autoFocus
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') handleSavePrimaryPhone();
                                                    if (e.key === 'Escape') setEditingPrimaryPhone(false);
                                                }}
                                            />
                                            <button onClick={handleSavePrimaryPhone} className="p-1 hover:bg-green-100 rounded">
                                                <Check className="w-3.5 h-3.5 text-green-600" />
                                            </button>
                                            <button onClick={() => setEditingPrimaryPhone(false)} className="p-1 hover:bg-accent rounded">
                                                <X className="w-3.5 h-3.5 text-muted-foreground" />
                                            </button>
                                        </div>
                                    ) : (
                                        <>
                                            <p className="text-sm text-foreground font-medium">{formatPhoneNumber(localPrimaryPhone)}</p>
                                            <button
                                                onClick={() => {
                                                    navigator.clipboard.writeText(localPrimaryPhone);
                                                    toast.success(t('dialer:prospectPanel.toasts.phoneCopied'));
                                                }}
                                                className="p-1 hover:bg-accent rounded transition-colors opacity-0 group-hover:opacity-100"
                                                title={t('common:actions.copy')}
                                            >
                                                <Copy className="w-3 h-3 text-muted-foreground" />
                                            </button>
                                            {prospect.id && (
                                                <button
                                                    onClick={() => { setEditPrimaryPhoneValue(localPrimaryPhone); setEditingPrimaryPhone(true); }}
                                                    className="p-1 hover:bg-accent rounded transition-colors opacity-0 group-hover:opacity-100"
                                                    title={t('admin:components.prospectDetail.editPhone')}
                                                >
                                                    <Edit3 className="w-3 h-3 text-muted-foreground" />
                                                </button>
                                            )}
                                            {!inline && onCall && (
                                                <button
                                                    onClick={() => onCall(prospect)}
                                                    className="p-1 hover:bg-green-100 rounded transition-colors opacity-0 group-hover:opacity-100"
                                                    title={t('common:actions.call')}
                                                >
                                                    <Phone className="w-3 h-3 text-green-600" />
                                                </button>
                                            )}
                                        </>
                                    )}
                                </div>

                                {/* Additional phones */}
                                {additionalPhones.map((phone, idx) => (
                                    <div key={idx} className="flex items-center gap-2 mt-1.5 group">
                                        {editingPhoneIdx === idx ? (
                                            <div className="flex items-center gap-1 flex-1">
                                                <Input
                                                    value={editingPhoneValue}
                                                    onChange={(e) => setEditingPhoneValue(e.target.value)}
                                                    className="h-7 text-sm flex-1"
                                                    autoFocus
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') handleUpdatePhone(idx);
                                                        if (e.key === 'Escape') {
                                                            setEditingPhoneIdx(null);
                                                            setEditingPhoneValue('');
                                                        }
                                                    }}
                                                />
                                                <button onClick={() => handleUpdatePhone(idx)} className="p-1 hover:bg-green-100 rounded">
                                                    <Check className="w-3.5 h-3.5 text-green-600" />
                                                </button>
                                                <button onClick={() => { setEditingPhoneIdx(null); setEditingPhoneValue(''); }} className="p-1 hover:bg-accent rounded">
                                                    <X className="w-3.5 h-3.5 text-muted-foreground" />
                                                </button>
                                            </div>
                                        ) : (
                                            <>
                                                <Star className="w-3.5 h-3.5 text-muted-foreground/40 flex-shrink-0" />
                                                <div className="flex-1 min-w-0">
                                                    <p className="text-sm text-foreground truncate">{formatPhoneNumber(phone.number)}</p>
                                                    {phone.label && <p className="text-xs text-muted-foreground/60">{phone.label}</p>}
                                                </div>
                                                <div className="flex items-center gap-0.5 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0">
                                                    <button
                                                        onClick={() => {
                                                            navigator.clipboard.writeText(phone.number);
                                                            toast.success(t('dialer:prospectPanel.toasts.phoneCopied'));
                                                        }}
                                                        className="p-1 hover:bg-accent rounded" title={t('common:actions.copy')}
                                                    >
                                                        <Copy className="w-3 h-3 text-muted-foreground" />
                                                    </button>
                                                    {!inline && onCall && (
                                                        <button
                                                            onClick={() => onCall({ ...prospect, prospect_phone: phone.number })}
                                                            className="p-1 hover:bg-green-100 rounded" title={t('admin:components.prospectDetail.callThisNumber')}
                                                        >
                                                            <Phone className="w-3 h-3 text-green-600" />
                                                        </button>
                                                    )}
                                                    <button
                                                        onClick={() => handleSetPrimaryPhone(idx)}
                                                        className="p-1 hover:bg-yellow-100 rounded" title={t('common:actions.setPrimary')}
                                                    >
                                                        <Star className="w-3 h-3 text-yellow-500" />
                                                    </button>
                                                    <button
                                                        onClick={() => { setEditingPhoneIdx(idx); setEditingPhoneValue(phone.number); }}
                                                        className="p-1 hover:bg-accent rounded" title={t('common:actions.edit')}
                                                    >
                                                        <Edit3 className="w-3 h-3 text-muted-foreground" />
                                                    </button>
                                                    <button
                                                        onClick={() => handleDeletePhone(idx)}
                                                        className="p-1 hover:bg-red-100 rounded" title={t('common:actions.delete')}
                                                    >
                                                        <Trash2 className="w-3 h-3 text-red-500" />
                                                    </button>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                ))}

                                {/* Add phone form */}
                                {isAddingPhone && (
                                    <div className="mt-2 bg-card rounded-lg p-2 border border-border space-y-1.5">
                                        <Input
                                            placeholder="+33 6 12 34 56 78"
                                            value={newPhone}
                                            onChange={(e) => setNewPhone(e.target.value)}
                                            className="h-7 text-sm"
                                            autoFocus
                                        />
                                        <Input
                                            placeholder={t('admin:components.prospectDetail.phoneLabelPlaceholder')}
                                            value={newPhoneLabel}
                                            onChange={(e) => setNewPhoneLabel(e.target.value)}
                                            className="h-7 text-sm"
                                            onKeyDown={(e) => { if (e.key === 'Enter') handleAddPhone(); }}
                                        />
                                        <div className="flex items-center gap-2">
                                            <Button size="sm" onClick={handleAddPhone} className="h-6 text-xs">
                                                {t('common:actions.add')}
                                            </Button>
                                            <Button size="sm" variant="ghost" onClick={() => { setIsAddingPhone(false); setNewPhone(''); setNewPhoneLabel(''); }} className="h-6 text-xs">
                                                {t('common:actions.cancel')}
                                            </Button>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {prospect.prospect_email && (
                                <div>
                                    <label className="text-xs font-semibold text-foreground/80 uppercase">{t('common:field.email')}</label>
                                    <div className="flex items-center gap-2 mt-1">
                                        <p className="text-sm text-foreground truncate">{prospect.prospect_email}</p>
                                        <button
                                            onClick={() => {
                                                navigator.clipboard.writeText(prospect.prospect_email);
                                                toast.success(t('dialer:prospectPanel.toasts.emailCopied'));
                                            }}
                                            className="p-1 hover:bg-accent rounded transition-colors flex-shrink-0"
                                            title={t('common:actions.copy')}
                                        >
                                            <Copy className="w-3.5 h-3.5 text-muted-foreground" />
                                        </button>
                                    </div>
                                </div>
                            )}

                            {prospect.notes && !prospect.notes.startsWith('[') && (
                                <div>
                                    <label className="text-xs font-semibold text-foreground/80 uppercase">{t('admin:components.prospectDetail.initialNotes')}</label>
                                    <p className="text-sm text-foreground mt-1 whitespace-pre-wrap">{prospect.notes}</p>
                                </div>
                            )}

                            <div>
                                <label className="text-xs font-semibold text-foreground/80 uppercase">{t('admin:components.prospectDetail.addedOn')}</label>
                                <p className="text-sm text-foreground mt-1">
                                    {formatDateTime(prospect.created_date)}
                                </p>
                            </div>

                            {/* 🚨 Kevin, 2026-09-30 : les trois boutons de priorite
                                (Basse, Moyenne, Haute) ont ete retires. Ils
                                ecrivaient un champ que l'ordre d'appel ne lit
                                pas : cliquer changeait une valeur en base et
                                rien a l'ecran ni dans la file. */}

                            {/* TICKET 6: Custom Fields Section */}
                            <div className="border-t border-border pt-4 mt-4">
                                <div className="flex items-center justify-between mb-3">
                                    <label className="text-xs font-semibold text-foreground/80 uppercase">{t('admin:components.prospectDetail.customFields')}</label>
                                    <button
                                        onClick={() => setIsAddingField(true)}
                                        className="p-1 hover:bg-accent rounded-full transition-colors"
                                        title={t('admin:components.prospectDetail.addField')}
                                    >
                                        <Plus className="w-4 h-4 text-foreground/70" />
                                    </button>
                                </div>

                                {/* Existing custom fields */}
                                {Object.keys(customFields).length > 0 && (
                                    <div className="space-y-2 mb-3">
                                        {Object.entries(customFields).map(([fieldName, fieldValue]) => (
                                            <div key={fieldName} className="group">
                                                <label className="text-xs text-muted-foreground">{libelleChampPerso(fieldName)}</label>
                                                {editingField === fieldName ? (
                                                    <div className="flex items-center gap-1 mt-0.5">
                                                        <Input
                                                            value={editingValue}
                                                            onChange={(e) => setEditingValue(e.target.value)}
                                                            className="h-7 text-sm flex-1"
                                                            autoFocus
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter') handleUpdateCustomField(fieldName);
                                                                if (e.key === 'Escape') {
                                                                    setEditingField(null);
                                                                    setEditingValue('');
                                                                }
                                                            }}
                                                        />
                                                        <button
                                                            onClick={() => handleUpdateCustomField(fieldName)}
                                                            className="p-1 hover:bg-green-100 rounded transition-colors"
                                                        >
                                                            <Check className="w-3.5 h-3.5 text-green-600" />
                                                        </button>
                                                        <button
                                                            onClick={() => {
                                                                setEditingField(null);
                                                                setEditingValue('');
                                                            }}
                                                            className="p-1 hover:bg-accent rounded transition-colors"
                                                        >
                                                            <X className="w-3.5 h-3.5 text-muted-foreground" />
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div className="flex items-center justify-between mt-0.5">
                                                        <p className="text-sm text-foreground">{fieldValue || '-'}</p>
                                                        <div className="flex items-center gap-0.5 opacity-0 group-hover:opacity-100 transition-opacity">
                                                            <button
                                                                onClick={() => {
                                                                    setEditingField(fieldName);
                                                                    setEditingValue(fieldValue);
                                                                }}
                                                                className="p-1 hover:bg-accent rounded transition-colors"
                                                                title={t('common:actions.edit')}
                                                            >
                                                                <Edit3 className="w-3 h-3 text-muted-foreground" />
                                                            </button>
                                                            <button
                                                                onClick={() => handleDeleteCustomField(fieldName)}
                                                                className="p-1 hover:bg-red-100 rounded transition-colors"
                                                                title={t('common:actions.delete')}
                                                            >
                                                                <Trash2 className="w-3 h-3 text-red-500" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                )}

                                {/* Add new field form */}
                                {isAddingField && (
                                    <div className="bg-card rounded-lg p-3 border border-border space-y-2">
                                        <Input
                                            placeholder={t('admin:components.prospectDetail.fieldNamePlaceholder')}
                                            value={newFieldName}
                                            onChange={(e) => setNewFieldName(e.target.value)}
                                            className="h-8 text-sm"
                                            autoFocus
                                        />
                                        <Input
                                            placeholder={t('admin:components.prospectDetail.fieldValuePlaceholder')}
                                            value={newFieldValue}
                                            onChange={(e) => setNewFieldValue(e.target.value)}
                                            className="h-8 text-sm"
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') handleAddCustomField();
                                            }}
                                        />
                                        <div className="flex items-center gap-2">
                                            <Button
                                                size="sm"
                                                onClick={handleAddCustomField}
                                                className="h-7 text-xs"
                                            >
                                                {t('common:actions.add')}
                                            </Button>
                                            <Button
                                                size="sm"
                                                variant="ghost"
                                                onClick={() => {
                                                    setIsAddingField(false);
                                                    setNewFieldName('');
                                                    setNewFieldValue('');
                                                }}
                                                className="h-7 text-xs"
                                            >
                                                {t('common:actions.cancel')}
                                            </Button>
                                        </div>
                                    </div>
                                )}

                                {Object.keys(customFields).length === 0 && !isAddingField && (
                                    <p className="text-xs text-muted-foreground/60 italic">{t('admin:components.prospectDetail.noCustomFields')}</p>
                                )}
                            </div>

                        </div>
                    </div>

                    {/* Right Content Area — min-w-0 essentiel pour que les enfants
                        avec contenu long (transcript, badges) ne forcent pas le
                        panneau à déborder horizontalement. */}
                    <div className="flex-1 min-w-0 flex flex-col min-h-0 bg-card">
                        {/* Card "appel en cours" — refonte modale unifiée 2026-05-21.
                            S'affiche en haut quand un appel est connecté pour CE prospet
                            (transcript live + coach + contrôles). Remplace l'ancienne
                            modale CallSheet séparée. */}
                        {(showLiveCard || isInboundActive) && (
                            <div className={inline ? "p-3 flex-shrink-0" : "p-4 flex-shrink-0"}>
                                {/* 2026-10-07: an iPhone screening assistant answered (amd_result
                                    'call_screening'): the caller states name and reason, the
                                    person may then pick up. */}
                                {showLiveCard && (activeCalls || []).some((c) => c.id === liveCallId && c.amd_result === 'call_screening') && (
                                    <div role="status" className="mb-3 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-100">
                                        {t('dialer:callScreening.banner')}
                                    </div>
                                )}
                                {/* 2026-06-05 — Pour les inbound, on utilise le CallSid
                                    Twilio comme cle de session STT. C'est ce qu'on a
                                    pose dans le TwiML <Stream callId="{CallSid}"/>. Pour
                                    les outbound, on continue avec le ParallelCall.id. */}
                                <LiveCallCard
                                    callId={isInboundActive ? (incomingSession.mediaCallSid || incomingSession.callSid || incomingSession.parallelCallId) : liveCallId}
                                    isInbound={isInboundActive || !(activeCalls || []).find((c) => c.id === liveCallId)?.prospect_id}
                                />
                            </div>
                        )}
                        {/* Tabs */}
                        <div className="border-b border-border px-6 pt-4 flex-shrink-0 bg-card">
                            <div className="flex gap-1">
                                {tabs.map((tab) => {
                                    const Icon = tab.icon;
                                    return (
                                        <button
                                            key={tab.id}
                                            onClick={() => setActiveTab(tab.id)}
                                            className={`px-4 py-3 text-sm font-medium transition-colors border-b-2 ${
                                                activeTab === tab.id
                                                    ? 'border-foreground text-foreground'
                                                    : 'border-transparent text-muted-foreground hover:text-foreground'
                                            }`}
                                        >
                                            <div className="flex items-center gap-2">
                                                <Icon className="w-4 h-4" />
                                                {tab.label}
                                            </div>
                                        </button>
                                    );
                                })}
                            </div>
                        </div>

                        {/* Tab Content — overflow-x-hidden + min-w-0 pour cap la
                            largeur (sinon transcripts/badges très longs poussent
                            tout le panel et cachent les boutons à droite). */}
                        <div className={inline ? "flex-1 min-h-0 min-w-0 overflow-y-auto overflow-x-hidden vf-scroll-discreet p-4" : "flex-1 min-h-0 min-w-0 overflow-y-auto overflow-x-hidden vf-scroll-discreet p-6"}>
                            {activeTab === 'activity' && (
                                /* L'onglet n'affichait qu'un etat vide, quoi qu'il se soit
                                   passe : les appels vivaient dans Historique, les SMS dans
                                   SMS, et rien ne reunissait les deux. Repondre a un SMS
                                   bascule sur l'onglet SMS avec la conversation ouverte. */
                                <ActivityTimeline
                                    calls={callHistory}
                                    sms={smsHistory}
                                    prospectPhone={prospect.prospect_phone}
                                    ourNumber={numeroEnvoi}
                                    onReply={() => setActiveTab('sms')}
                                />
                            )}

                            {activeTab === 'notes' && (
                                <ProspectNotesTab
                                    prospect={prospect}
                                    parsedNotes={parsedNotes}
                                    notes={notes}
                                    setNotes={setNotes}
                                    newNote={newNote}
                                    setNewNote={setNewNote}
                                    savingNote={savingNote}
                                    setSavingNote={setSavingNote}
                                    queryClient={queryClient}
                                    liveCallId={liveCallId}
                                    liveCallNotes={((activeCalls || []).find((c) => c.id === liveCallId) || callHistory.find((c) => c.id === liveCallId))?.call_notes || ''}
                                />
                            )}

                            {activeTab === 'calls' && (
                                <ProspectCallsTab
                                    prospect={prospect}
                                    callHistory={callHistory}
                                    allCallsExpanded={allCallsExpanded}
                                    setAllCallsExpanded={setAllCallsExpanded}
                                    expandedCalls={expandedCalls}
                                    setExpandedCalls={setExpandedCalls}
                                    toggleCallExpanded={toggleCallExpanded}
                                    getCallStatusStyle={getCallStatusStyle}
                                    handleDispositionUpdate={handleDispositionUpdate}
                                    savingDisposition={savingDisposition}
                                    idLienCopieFiche={idLienCopieFiche}
                                    setIdLienCopieFiche={setIdLienCopieFiche}
                                />
                            )}

                            {/* TICKET 39: Transcription tab */}
                            {activeTab === 'transcription' && (
                                <div className="space-y-3">
                                    <h3 className="font-semibold text-foreground mb-2">{t('admin:components.prospectDetail.transcriptions')} — {prospect.prospect_name}</h3>
                                    {callHistory.length === 0 ? (
                                        <div className="text-center py-8">
                                            <FileText className="w-10 h-10 text-muted-foreground/40 mx-auto mb-2" />
                                            <p className="text-sm text-muted-foreground/60">{t('admin:components.prospectDetail.noRecording')}</p>
                                        </div>
                                    ) : (
                                        callHistory
                                            .filter(c => c.call_status === 'completed' && c.duration_seconds > 0)
                                            .slice(0, 10)
                                            .map(call => (
                                                <CallTranscription key={call.id} call={call} />
                                            ))
                                    )}
                                    {callHistory.filter(c => c.call_status === 'completed' && c.duration_seconds > 0).length === 0 && callHistory.length > 0 && (
                                        <p className="text-xs text-muted-foreground/60 text-center">{t('admin:components.prospectDetail.noConnectedToTranscribe')}</p>
                                    )}
                                </div>
                            )}

                            {activeTab === 'sms' && (
                                <ProspectSmsTab
                                    prospect={prospect}
                                    smsHistory={smsHistory}
                                    smsTemplates={smsTemplates}
                                    smsMessage={smsMessage}
                                    setSmsMessage={setSmsMessage}
                                    sendingSms={sendingSms}
                                    handleSendSms={handleSendSms}
                                    numerosSms={numerosSms}
                                    numeroEnvoi={numeroEnvoi}
                                    setNumeroEnvoi={setNumeroEnvoi}
                                />
                            )}
                        </div>

                    </div>

                {/* 2026-06-04 (refactor big-bang) — Barre bas CENTREE.
                    Affichage dependant de la session ou du pillState classique :
                    - Inbound : session.isLive (boutons visibles) / session.isEnded (caches)
                    - Outbound : showLiveCard && pillState !== ended/voicemail
                    Quand session.isEnded, la modale reste ouverte mais SANS boutons :
                    c'est l'etat "Appel termine" demande par Kevin. */}
                {((isInboundActive && incomingSession.isLive) || (!isInboundActive && showLiveCard && pillState !== 'ended' && pillState !== 'voicemail')) && effectiveHangup && (
                    <div className="absolute bottom-0 left-0 right-0 z-[40] border-t border-border bg-card px-6 py-4">
                        <div className="flex items-center justify-center gap-3">
                            {/* Couper le micro, a gauche de Raccrocher. Une icone
                                seule : c'est un geste qu'on fait sans lire. */}
                            <button
                                type="button"
                                aria-pressed={isMuted}
                                title={t(isMuted ? 'dialer:callBar.unmute' : 'dialer:callBar.mute')}
                                aria-label={t(isMuted ? 'dialer:callBar.unmute' : 'dialer:callBar.mute')}
                                onClick={() => {
                                    const suivant = !isMuted;
                                    if (!applyMute(suivant)) {
                                        toast.error(t('dialer:callBar.muteUnavailable'));
                                        return;
                                    }
                                    setIsMuted(suivant);
                                }}
                                className={`inline-flex items-center justify-center rounded-md w-10 h-10 border transition-colors ${
                                    isMuted
                                        ? 'bg-red-50 border-red-200 text-red-600'
                                        : 'bg-card border-border text-muted-foreground hover:text-foreground'
                                }`}
                            >
                                {isMuted ? <MicOff className="w-4 h-4" /> : <Mic className="w-4 h-4" />}
                            </button>
                            <button
                                type="button"
                                onClick={async () => {
                                    // RUI-P2 : apres le raccroche, la fiche reste
                                    // ouverte pour qualifier l'appel (onglet Statut).
                                    // L'arret vide la fiche globale : on la rouvre
                                    // si c'est bien ce contact. Une fiche locale
                                    // (Historique) reste ouverte d'elle-meme.
                                    try { await effectiveHangup(); } catch { /* ignore */ }
                                    if (lastProspectContacted?.id && lastProspectContacted.id === prospect?.id) reopenLastProspect();
                                }}
                                className="inline-flex items-center gap-2 rounded-md px-5 h-10 text-sm font-semibold text-white"
                                style={{ background: 'var(--vf-red, #dc2626)' }}
                            >
                                <PhoneOff className="w-4 h-4" />
                                {t('dialer:onCall.hangUp')}
                            </button>
                            {powerMode && hangupNext && !isInboundActive && (
                                <button
                                    type="button"
                                    onClick={async () => {
                                        try { await hangupNext(); } catch { /* ignore */ }
                                        if (onClose) onClose();
                                    }}
                                    className="inline-flex items-center gap-2 rounded-md px-5 h-10 text-sm font-semibold border"
                                    style={{
                                        background: 'var(--vf-surface-1, white)',
                                        color: 'var(--vf-text-1, #111827)',
                                        borderColor: 'var(--vf-border, #e5e7eb)',
                                    }}
                                >
                                    {t('dialer:onCall.hangUpNext')}
                                </button>
                            )}
                        </div>
                    </div>
                )}

                {/* Delete confirmation overlay — inside root content div for Radix Dialog compatibility */}
                {confirmDelete && (
                    <div className="absolute inset-0 z-[50] flex items-center justify-center bg-black/50 rounded-2xl" onClick={() => setConfirmDelete(false)}>
                        <div className="bg-card border border-border rounded-xl shadow-xl p-6 max-w-sm w-full mx-4" onClick={(e) => e.stopPropagation()}>
                            <h3 className="text-lg font-semibold mb-2">{t('admin:components.prospectDetail.deleteContact')}</h3>
                            <p className="text-sm text-muted-foreground mb-4">
                                {t('dialer:prospectPanel.deleteConfirm', { name: prospect.prospect_name })}
                            </p>
                            <div className="flex justify-end gap-2">
                                <button
                                    onClick={() => setConfirmDelete(false)}
                                    className="px-4 py-2 text-sm rounded-lg border border-border hover:bg-accent transition-colors"
                                >
                                    {t('common:actions.cancel')}
                                </button>
                                <button
                                    onClick={handleDeleteProspect}
                                    className="px-4 py-2 text-sm rounded-lg bg-red-600 text-white hover:bg-red-700 transition-colors"
                                >
                                    {t('common:actions.delete')}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
        </div>
    );

    // Mini-modale Edit Identity — rendue via Dialog Radix (Portal) pour eviter
    // les problemes de positionnement dans le panel scrollable. Partagee entre
    // les modes inline et non-inline.
    const editIdentityDialog = (
        <Dialog open={editIdentityOpen} onOpenChange={(o) => !savingIdentity && setEditIdentityOpen(o)}>
            <DialogContent className="max-w-sm p-6">
                <h3 className="text-lg font-semibold mb-4">{t('dialer:prospectPanel.editIdentity.title')}</h3>
                <div className="space-y-3 mb-4">
                    <div>
                        <label className="text-sm font-medium text-foreground block mb-1">{t('dialer:prospectPanel.editIdentity.nameLabel')}</label>
                        <Input
                            value={editName}
                            onChange={(e) => setEditName(e.target.value)}
                            placeholder={t('dialer:prospectPanel.editIdentity.namePlaceholder')}
                            autoFocus
                            disabled={savingIdentity}
                        />
                    </div>
                    <div>
                        <label className="text-sm font-medium text-foreground block mb-1">{t('common:field.company')}</label>
                        <Input
                            value={editCompany}
                            onChange={(e) => setEditCompany(e.target.value)}
                            disabled={savingIdentity}
                        />
                    </div>
                    <div>
                        <label className="text-sm font-medium text-foreground block mb-1">{t('dialer:prospectPanel.editIdentity.statusLabel')}</label>
                        <Select
                            value={editStatus || 'keep'}
                            onValueChange={(v) => setEditStatus(v === 'keep' ? '' : v)}
                            disabled={savingIdentity}
                        >
                            <SelectTrigger className="w-full"><SelectValue /></SelectTrigger>
                            <SelectContent>
                                <SelectItem value="keep">{t('dialer:prospectPanel.editIdentity.statusKeep')}</SelectItem>
                                <SelectItem value="new">{t('dialer:status.new')}</SelectItem>
                                {/* RUI-05 : pas de « Rappel demandé » ici. Ce statut sortait le contact
                                    des prêts à appeler sans date, donc sans tâche dans Tâches ; un
                                    rappel se planifie sur l'appel (date, heure, fuseau). */}
                                {STATUS_OVERRIDE_VALUES.map((k) => (
                                    <SelectItem key={k} value={k}>{outcomeLabel(k, t)}</SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                    </div>
                    <div>
                        <label className="text-sm font-medium text-foreground block mb-1">{t('dialer:prospectPanel.editIdentity.leadStatusLabel')}</label>
                        <Select
                            value={editLeadStatus || 'keep'}
                            onValueChange={(v) => setEditLeadStatus(v === 'keep' ? '' : v)}
                            disabled={savingIdentity}
                        >
                            <SelectTrigger className="w-full"><SelectValue /></SelectTrigger>
                            <SelectContent>
                                <SelectItem value="keep">{t('dialer:prospectPanel.editIdentity.leadStatusKeep')}</SelectItem>
                                {LEAD_STATUS_VALUES.map((k) => (
                                    <SelectItem key={k} value={k}>{leadStatusLabel(k, t)}</SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                    </div>
                    <div>
                        <label className="text-sm font-medium text-foreground block mb-1">{t('dialer:prospectPanel.editIdentity.linkedinLabel')}</label>
                        <Input
                            value={editLinkedin}
                            onChange={(e) => setEditLinkedin(e.target.value)}
                            placeholder="https://www.linkedin.com/in/jean-dupont"
                            disabled={savingIdentity}
                        />
                    </div>
                </div>
                <div className="flex justify-end gap-2">
                    <button
                        onClick={() => setEditIdentityOpen(false)}
                        disabled={savingIdentity}
                        className="px-4 py-2 text-sm rounded-lg border border-border hover:bg-accent transition-colors disabled:opacity-50"
                    >
                        {t('common:actions.cancel')}
                    </button>
                    <button
                        onClick={handleSaveIdentity}
                        disabled={savingIdentity}
                        className="px-4 py-2 text-sm rounded-lg bg-primary text-primary-foreground hover:opacity-90 transition-opacity disabled:opacity-50 inline-flex items-center gap-2"
                    >
                        {savingIdentity && <Loader2 className="w-3.5 h-3.5 animate-spin" />}
                        {t('common:actions.save')}
                    </button>
                </div>
            </DialogContent>
        </Dialog>
    );

    if (inline) {
        return (
            <>
                {content}
                {editIdentityDialog}
            </>
        );
    }

    return (
        <>
            <Dialog
                open={isOpen}
                onOpenChange={(open) => {
                    // 2026-06-04 (Kevin demo bug C) — Le X doit toujours fermer
                    // la modale (geste delibere de l'agent). Les gestes
                    // accidentels (clic overlay, Echap) restent bloques
                    // pendant un appel en cours via onInteractOutside et
                    // onEscapeKeyDown ci-dessous.
                    if (!open && onClose) onClose();
                }}
            >
                <DialogContent
                    instant={showLiveCard}
                    className="max-w-5xl max-h-[85vh] h-[85vh] p-0 gap-0 overflow-hidden"
                    onInteractOutside={(e) => { if (showLiveCard) e.preventDefault(); }}
                    onEscapeKeyDown={(e) => { if (showLiveCard) e.preventDefault(); }}
                >
                    {content}
                </DialogContent>
            </Dialog>
            {editIdentityDialog}
        </>
    );
}